import { render, staticRenderFns } from "./UdSelect.vue?vue&type=template&id=5b91ef74&scoped=true&"
import script from "./UdSelect.vue?vue&type=script&lang=js&"
export * from "./UdSelect.vue?vue&type=script&lang=js&"
import style0 from "./UdSelect.vue?vue&type=style&index=0&id=5b91ef74&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b91ef74",
  null
  
)

export default component.exports